import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "GlobalCarApplications" })
export default class GlobalCarApplications extends Vue {
    public localizer: any = Localizer;
    public brandCode: string = null;
    public modelYear: string = null;
    public modelCode: string = null;
    public typeCode: string = null;

    public isLoading: boolean = false;
    public isCompatibility: boolean = false;
    public applicationUrl: string = null;

    public isProductApplicationBrandsLoader: boolean = false;
    public isProductApplicationsLoader: boolean = false;
    public isProductApplicationList: boolean = false;

    public brandList: any[] = [];
    public modelYearList: any[] = [];
    public modelList: any[] = [];
    public typeList: any[] = [];

    public selectedProductApplicationBrand: any = null;
    public productApplications: any[] = [];

    public pageCount: number = 0;
    public pageIndex: number = 0;

    @Prop() readonly region: string;
    @Prop() readonly bremboCode: string;
    @Prop() readonly marketType: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.isLoading = true;
        await this.getBrandList();
        this.isLoading = false;

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('compatibility')) {
            (<any>this).$refs.globalCarApplications.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    }

    public async getBrandList() {
        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductApplicationBrands, { bremboCode: this.bremboCode })).data;
        this.brandList = response;
    }

    public async getModelYearList() {
        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductApplicationModels, { bremboCode: this.bremboCode, brandCode: this.brandCode })).data;

        if (response) {
            const uniqueNamesSet = new Set();

            this.modelYearList = response.map((({ modelYear }) => ({ title: modelYear, value: modelYear }))).filter(x => {
                if (!uniqueNamesSet.has(x.value)) {
                    uniqueNamesSet.add(x.value);
                    return true;
                }
                return false;
            }).toSorted(x => x.value);
        } else {
            this.modelYearList = [];
        }
    }

    public async getModelList() {
        this.modelList = [];

        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductApplicationModels, { bremboCode: this.bremboCode, brandCode: this.brandCode })).data;
        for (var item of response) {
            if (this.modelList.filter(x => x.modelCode === item.modelCode).length === 0) {
                this.modelList.push({ modelCode: item.modelCode, modelName: item.modelName, modelYear: item.modelYear });
            }
        }

        if (this.region === "america") {
            this.modelList = this.modelList.filter(x => x.modelYear === this.modelYear);
        }
    }

    public async getTypeList() {
        this.typeList = [];

        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductApplicationModels, { bremboCode: this.bremboCode, brandCode: this.brandCode, modelCode: this.modelCode })).data;
        this.typeList = response.filter(x => x.modelCode === this.modelCode);
    }

    public async onBrandCodeChanged() {
        if (!this.brandCode) {
            this.modelList = [];
            this.modelYearList = [];
            this.brandCode = null;
        } else if (this.brandCode) {
            this.isLoading = true;
            if (this.region === 'america') {
                await this.getModelYearList();
            } else {
                await this.getModelList();
            }
            this.isLoading = false;
        }

        this.modelYear = null;
        this.modelCode = null;
        this.typeCode = null;
        this.isCompatibility = false;
    }

    public async onModelYearChanged() {
        if (!this.modelYear) {
            this.modelList = [];
            this.typeList = [];
            this.modelCode = null;
            this.typeCode = null;
        } else if (this.modelYear) {
            this.isLoading = true;
            await this.getModelList();
            this.isLoading = false;
        }

        this.modelCode = null;
        this.typeCode = null;
        this.isCompatibility = false;
    }

    public async onModelCodeChanged() {
        if (!this.modelCode) {
            this.typeList = [];
            this.modelCode = null;
        } else if (this.modelCode) {
            this.isLoading = true;
            await this.getTypeList();
            this.isLoading = false;
        }

        this.typeCode = null;
        this.isCompatibility = false;
    }

    public onTypeCodeChanged() {
        this.isCompatibility = false;
    }

    public async getIsCompatibility() {
        const hasBrandModelType = this.brandCode != null && this.modelCode != null && this.typeCode != null;

        this.isCompatibility = this.region === "america" ? this.modelYear && hasBrandModelType : hasBrandModelType;
        if (this.isCompatibility) {
            GTagHelper.sendEvent("click", "compatibility", "check");
        }
    }

    public async showProductApplicationList() {
        if (!this.brandList || this.brandList.length === 0) {
            this.isProductApplicationBrandsLoader = true;

            await this.getBrandList();

            this.isProductApplicationBrandsLoader = false;
        }

        if (!this.selectedProductApplicationBrand) {
            this.selectedProductApplicationBrand = this.brandCode ? this.brandList.find(x => x.brandCode === this.brandCode) : this.brandList[0];
            this.getProductApplications(this.selectedProductApplicationBrand.brandCode, 1);
            GTagHelper.sendEvent("click", "compatibility", "open_list");

            this.$nextTick(function () {
                this.checkIsInViewport();
            });
        }

        this.isProductApplicationList = true;
    }

    public checkIsInViewport() {
        let myElement = <any>document.querySelector(".item[data-selected='true']");
        let box = <any>document.querySelector(".tabs");

        box.scrollLeft = myElement.offsetLeft - box.offsetLeft - 50;
    }

    public async getProductApplications(brandCode: string, page: number) {
        this.isProductApplicationsLoader = true;

        const response = (await Axios.post(this.routes.CatalogueGlobalCarList_GetProductApplications, { bremboCode: this.bremboCode, brandCode: brandCode, page: page })).data;
        this.productApplications = response.applicationItems;
        this.pageCount = response.pageCount;
        this.pageIndex = response.pageIndex;

        this.isProductApplicationsLoader = false;
    }

    public setSelectedProductApplicationBrand(productApplicationBrand: any) {
        if (this.selectedProductApplicationBrand !== productApplicationBrand) {
            this.selectedProductApplicationBrand = productApplicationBrand;
            this.getProductApplications(this.selectedProductApplicationBrand.brandCode, 1);
        }
    }

    public async setPage(page: number) {
        await this.getProductApplications(this.selectedProductApplicationBrand.brandCode, page);
    }

    public getProductApplicationYear(dateStart: string, dateEnd: string) {
        return dateStart + " - " + dateEnd;
    }

    public async searchApplication(brandCode: string, modelYear: string, modelCode: string, typeCode: string) {
        const response = (await Axios.post(this.routes.CatalogueGlobalCarSearch_SearchType, { brandCode: brandCode, modelYear: modelYear, modelCode: modelCode, typeCode: typeCode })).data;

        if (response) {
            GTagHelper.sendEvent("click", "compatibility", "application");
            window.location.href = response.url;
        }
    }
}